/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { brandingsIndex } from '../../axios/brandingsIndex'
import type { BrandingsIndexError, BrandingsIndexQueryParams, BrandingsIndexResponse } from '../../types/BrandingsIndex'

export const brandingsIndexQueryKey = (params?: BrandingsIndexQueryParams) =>
	[{ url: '/brandings' }, ...(params ? [params] : [])] as const

export type BrandingsIndexQueryKey = ReturnType<typeof brandingsIndexQueryKey>

/** @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::index */
export function brandingsIndexQueryOptions(params?: BrandingsIndexQueryParams, config?: AxiosRequestConfig) {
	return queryOptions<
		BrandingsIndexResponse,
		AxiosError<BrandingsIndexError>,
		BrandingsIndexResponse,
		BrandingsIndexQueryKey
	>({
		queryKey: brandingsIndexQueryKey(params),
		queryFn: ({ signal }) => brandingsIndex(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::index */
export function useBrandingsIndex<TSelectData = BrandingsIndexResponse>(
	params?: BrandingsIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					BrandingsIndexResponse,
					AxiosError<BrandingsIndexError>,
					TSelectData,
					BrandingsIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<BrandingsIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...brandingsIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::index */
export function useBrandingsIndexSuspense<TSelectData = BrandingsIndexResponse>(
	params?: BrandingsIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					BrandingsIndexResponse,
					AxiosError<BrandingsIndexError>,
					TSelectData,
					BrandingsIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<BrandingsIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...brandingsIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
